import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({}));

export default useStyles;
